const CustomerChannelStatistics = () =>
  import('@/views/main/wechatMgmt/customerChannelStatistics/CustomerChannelStatistics.vue')
export default {
  path: '/main/wechatMgmt/customerChannelStatistics',
  name: 'CustomerChannelStatistics',
  component: CustomerChannelStatistics
}
